import {FC, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import BoundTariffForm from './components/BoundTariffForm'
import MFNTariffForm from './components/MFNTariffForm'
import PrefTariffForm from './components/PrefTariffForm'
import {getHSCodesFromHSDescriptions, getHSVersionsFromHSDescription} from './core/_requests'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'

const TariffDetailPage: FC<{subject: string}> = ({subject}) => {
  const axiosPrivate = useAxiosPrivate()
  const {typeTariff} = useParams()
  const [HSVersions, setHSVersions] = useState<any[]>([])
  const [HSCodes, setHSCodes] = useState<any[]>([])

  useEffect(() => {
    getHSVersionsFromHSDescription(axiosPrivate)
      .then((res) => {
        setHSVersions(res.data.data)
      })
      .catch((err) => console.error(err))

    getHSCodesFromHSDescriptions(axiosPrivate, {})
      .then((res) => setHSCodes(res.data.data))
      .catch((err) => console.error(err))
  }, [])

  const renderForm = () => {
    switch (typeTariff) {
      case 'bound':
        return (
          <BoundTariffForm
            HSVersions={HSVersions}
            HSCodes={HSCodes}
            type={typeTariff}
            subject={subject}
          />
        )
      case 'mfn':
        return (
          <MFNTariffForm
            HSVersions={HSVersions}
            HSCodes={HSCodes}
            type={typeTariff}
            subject={subject}
          />
        )
      case 'pref':
        return (
          <PrefTariffForm
            HSVersions={HSVersions}
            HSCodes={HSCodes}
            type={typeTariff}
            subject={subject}
          />
        )
    }
  }

  return (
    <>
      <div className='LegalTinaDetailPage'>{renderForm()}</div>
    </>
  )
}

export default TariffDetailPage
